import React from 'react';

class Api extends React.Component {

  render() {
    return (
      <div>
        <div className="modal" id="api" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title" id="myModalLabel">API</h4>
              </div>
              <div className="modal-body">
                <div className="container-fluid">
                  <p>
                    Do you want to display ClimateList maps on your own website?
                  </p>
                  <p>
                    It's not a feature that is available today, but I'm considering it. I would love to see your website and discuss what you need.
                  </p>
                  <div className="beta-alert-box" role="alert" >
                    <h4 className="title">API Beta Testers</h4>
                    <div id="mc_embed_signup">
                    <form action="//climatelist.us11.list-manage.com/subscribe/post?u=f2cca2534a425dd7b18ec2569&amp;id=41672e7775" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
                      <div id="mc_embed_signup_scroll">
                        <div className="mc-field-group form-group">
                          <label htmlFor="mce-EMAIL">Email address</label>
                          <input type="email" name="EMAIL" className="required email form-control" id="mce-EMAIL" />
                        </div>
                        <div className="mc-field-group form-group">
                          <label htmlFor="mce-FNAME">First Name</label>
                          <input type="text" name="FNAME" className="required form-control" id="mce-FNAME" />
                        </div>
                        <div className="mc-field-group form-group">
                          <label htmlFor="mce-MMERGE3">Your Website</label>
                          <input type="url" name="MMERGE3" className="required url form-control" id="mce-MMERGE3" />
                        </div>
                        <div style={{position:'absolute',left:'-5000px'}} aria-hidden="true"><input type="text" name="b_f2cca2534a425dd7b18ec2569_f980b4abd7" tabIndex="-1" value="" /></div>
                        <input type="submit" value="Let's talk!" name="subscribe" id="mc-embedded-subscribe" className="button btn btn-primary" />
                      </div>
                    </form>
                    </div>
                    <p />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <br />
                <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Api;



/** WEBPACK FOOTER **
 ** ./src/components/Api.js
 **/